<template>
    <div>
        <div class="title">
            <h4>门店列表</h4>
        </div>
        <!-- 搜索框 -->
        <div class="searchBox" ref="searchBox">
            <el-form :inline="true" :model="table.searchForm" ref="searchForm" class="demo-form-inline"
                label-width="100px" size="mini">
                <div class="inpBox">
                    <el-form-item label="店名: " prop="name">
                        <el-input placeholder="" v-model="table.searchForm.name"></el-input>
                    </el-form-item>
                </div>
                <div class="searchBtnBox">
                    <el-form-item>
                        <el-button type="primary" @click="tableSearch">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="tableResetForm">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="editDialogOpen">创建</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="table" :style="{ height: table.height }">
            <el-table :data="table.tableList" ref="table" v-loading="table.loading" @row-click="tableHandleRowClick"
                highlight-current-row bordersize="mini" height="100%" style="width: 100%" center border>
                <el-table-column fixed type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="text" size="mini" v-show="scope.row.status == 0"
                                @click="editStatus(scope.row, 1)">禁用</el-button>
                            <el-button style="margin: 0 !important" type="text" size="mini"
                                v-show="scope.row.status == 1" @click="editStatus(scope.row, 0)">恢复</el-button>
                            <el-button type="text" size="mini" @click="editDialogEdit(scope.row)">编辑</el-button>
                            <!-- <el-button type="text" size="mini" @click="branchDelete(scope.row)">删除</el-button> -->
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" min-width="180" label="名称"></el-table-column>
                <el-table-column prop="phone" min-width="180" label="手机号"></el-table-column>
                <el-table-column prop="account" min-width="180" label="账号"></el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination background @size-change="pagerHandleSizeChange" @current-change="pagerHandleCurrentChange"
                :current-page="table.searchForm.pageNo" :page-sizes="[10, 20, 50, 100]"
                :page-size="table.searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="table.total"> </el-pagination>
        </div>
        <!-- 新建或编辑弹窗 -->
        <el-dialog :title="editDialog.title" :close-on-click-modal="false" :close-on-press-escape="false" class="vehm"
            :visible.sync="editDialog.visible" @close="editDialogClose" @opened="editDialogOpen" width="1200px" center>
            <span>
                <el-form :inline="true" :rules="editDialog.rules" :model="editDialog.form" ref="editDialogForm"
                    class="demo-form-inline jiaoyan" label-width="100px" size="mini">
                    <el-form-item label="账号:" prop="account" v-if="editDialog.operation == 'add'">
                        <el-input placeholder="" v-model="editDialog.form.account" style="width: 150px"
                            :readonly="editDialog.operation == 'edit'" autocomplete="new-password"></el-input>
                    </el-form-item>
                    <el-form-item label="密码:" prop="password" v-if="editDialog.operation == 'add'">
                        <el-input placeholder="" v-model="editDialog.form.password" show-password
                            autocomplete="new-password"  style="width: 150px"></el-input>
                    </el-form-item>
                    <br />
                    <el-form-item label="店名:" prop="name">
                        <el-input placeholder=""  style="width: 150px" v-model="editDialog.form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="位置:" prop="district" v-if="editDialog.operation == 'add'">
                        <el-row v-model="editDialog.form.district">
                            <el-select v-model="editDialog.province" placeholder="请选择省" @change="changePro">
                                <el-option v-for="item in addressData" :key="item.code" :label="item.name" :value="item.name" ></el-option>
                            </el-select>
                            <el-select v-model="editDialog.city"  style="width: 150px;margin-left: 20px;" placeholder="请选择市" @change="changeCity">
                                <el-option v-for="item in cityData" :key="item.code" :label="item.name" :value="item.name"></el-option>
                            </el-select>
                            <el-select v-model="editDialog.area" style="width: 150px;margin-left: 20px;"  placeholder="请选择区" @change="changeArea">
                                <el-option v-for="item in areaData" :key="item.code" :label="item.name" :value="item.name" ></el-option>
                            </el-select>
                        </el-row>
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialog.visible = false">取消</el-button>
                <el-button type="primary" @click="editDialogSave">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    /* eslint-disable */
    import { branchList, branchAdd, branchEdit, branchDelete, districtList } from "@/api/request";
    import { Message } from "element-ui";
    export default {
        data() {
            return {
                //  省数据
                addressData: [],
                //  市数据
                cityData: [],
                // 区数据
                areaData: [],
                table: {
                    height: "500px",
                    loading: false,
                    total: 0,
                    tableList: [],
                    searchForm: {
                        pageNo: 1,
                        pageSize: 10,
                    },
                },
                isShow:false,
                district:[],
                editDialog: {
                    title: "创建门店",
                    operation: "add",
                    form: {
                        district:'',
                    },
                    province: "",
                    // 市
                    city: "",
                    // 区
                    area: "",
                    visible: false,
                    genderList: [
                        { value: 0, label: "男" },
                        { value: 1, label: "女" },
                        { value: 2, label: "保密" },
                    ],
                    roleList: [
                        { value: 1, label: "管理员1" },
                        { value: 2, label: "管理员2" },
                        { value: 3, label: "管理员3" },
                    ],
                    rules: {
                        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
                        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                        name: [{ required: true, message: "请输入店名", trigger: "blur" }],
                        // district: [{ required: true, message: "请输入所属区域", trigger: "change" }],
                    },
                },
            };
        },
        created() {
            this.tableGetList(this.table.searchForm);
            this.getProvince()
        },
        mounted() {},
        methods: {
            //获取省市区
            getDistrictList(id,number){
                districtList({pid:id})
                    .then(
                        (res) => {
                            console.log(res);
                            if(number==1){
                                this.addressData = res.data.list
                            }else if(number==2){
                                this.cityData = res.data.list
                            }else{
                                this.areaData = res.data.list
                            }
                        },
                        (res) => {

                        }
                    )
                    .catch((error) => {
                        console.log(error);
                    });
            },
            //获取省份数据
            getProvince(){
                this.getDistrictList(0,1)              
            },
            //获取城市数据
            changePro(e){
                console.log(e);
                var proId = this.addressData.filter((item) => {
                    return item.name == e;
                })[0].id
                var proCode = this.addressData.filter((item) => {
                    return item.name == e;
                })[0].code
                // console.log( proId);
                this.district=[]
                this.areaData = []
                this.editDialog.city=''
                this.editDialog.area=''
                this.district.push(proCode)
                this.getDistrictList(proId,2)
            },
            
            //获取地区数据
            changeCity(e){
                console.log(e);
                this.editDialog.area=''
                var cityId = this.cityData.filter((item) => {
                    return item.name == e;
                })[0].id
                var cityCode = this.cityData.filter((item) => {
                    return item.name == e;
                })[0].code
                // console.log(this.district[1]);
                this.district.splice(1)
                this.district.push(cityCode)
                // console.log( cityId);
               console.log(this.district);
                this.getDistrictList(cityId,3)
            },
            //获取地区Id
            changeArea(e){
                this.$refs.editDialogForm.clearValidate('district');
                console.log(e);
                var areaId = this.areaData.filter((item) => {
                    return item.name == e;
                })[0].id
                var areaCode = this.areaData.filter((item) => {
                    return item.name == e;
                })[0].code
                this.district.splice(2)
                // console.log(areaId);
                this.district.push(areaCode)
                this.editDialog.form.district=this.district.join('-')
                // console.log(this.district.join('-'));
                console.log(this.editDialog.form.district);
            },
            // 编辑窗口: 关闭对话框后(渲染结束)执行. 恢复窗口初始状态
            editDialogClose() {
                this.$nextTick(() => {
                    this.editDialog.form = {};
                    this.editDialog.form.district=''
                    this.editDialog.title = "创建门店";
                    this.editDialog.operation = "add";
                    this.$refs.editDialogForm.clearValidate();
                    this.editDialog.province=''
                    this.editDialog.city=''
                    this.editDialog.area=''
                    this.cityData = []
                    this.areaData = []
                });
            },
            // 编辑窗口: 打开. 通用设置
            editDialogOpen() {
                this.editDialog.visible = true;
                // this.$refs.editDialogForm.clearValidate()
            },
            // 编辑窗口: 编辑. 同时触发editDialogOpen()
            editDialogEdit(row) {
                this.editDialog.title = "编辑门店";
                this.editDialog.visible = true;
                this.editDialog.operation = "edit";
                this.editDialog.form = row;
            },
            editDialogDelete(row) {},
            editDialogSave() {
                this.$refs.editDialogForm.validate((valid) => {
                    if (valid) {
                        if(this.editDialog.form.district ==''){
                        Message({
                            message: '请选择所属区域',
                            duration: 800,

                        });
                        } else {
                            // 全屏遮罩. 不是表格遮罩
                            const loading = this.$loading({
                                lock: true,
                                text: "正在处理...",
                            });
                            if (this.editDialog.operation == "add") {
                                // console.log(this.editDialog.form.district);
                                //数据处理
                                let arr ={
                                   account:this.editDialog.form.account,
                                   name:this.editDialog.form.name,
                                   password:this.editDialog.form.password,
                                   district:this.district.join('-')
                                }
                                branchAdd(arr)
                                    .then(
                                        (res) => {
                                            Message({
                                                message: `${res.message}`,
                                                type: "success",
                                                duration: 800,
                                                onClose: () => {
                                                    console.log("res", res);
                                                    loading.close();
                                                    this.editDialog.visible = false;
                                                    this.tableGetList(this.table.searchForm);
                                                },
                                            });
                                        },
                                        (res) => {
                                            Message({
                                                message: `${res.message}`,
                                                type: "error",
                                                duration: 1500,
                                                onClose: () => {
                                                    loading.close();
                                                },
                                            });
                                        }
                                    )
                                    .catch((error) => {
                                        console.log(error);
                                    });
                            } else if (this.editDialog.operation == "edit") {
                                branchEdit(this.editDialog.form)
                                    .then(
                                        (res) => {
                                            Message({
                                                message: `${res.message}`,
                                                type: "success",
                                                duration: 800,
                                                onClose: () => {
                                                    console.log("res", res);
                                                    loading.close();
                                                    this.editDialog.visible = false;
                                                    this.tableGetList(this.table.searchForm);
                                                },
                                            });
                                        },
                                        (res) => {
                                            Message({
                                                message: `${res.message}`,
                                                type: "error",
                                                duration: 1500,
                                                onClose: () => {
                                                    loading.close();
                                                },
                                            });
                                        }
                                    )
                                    .catch((error) => {
                                        this.$message({
                                            showClose: true,
                                            message: error instanceof Object && error.message !== undefined ? error.message : "Cannot parse response",
                                            type: "error",
                                            onClose() { },
                                        });
                                    });
                            }
                    }
                        
                    }
                });
            },
            editStatus(row, value) {
                const loading = this.$loading({
                    lock: true,
                    text: "正在处理...",
                });
                branchEdit({ ...row, status: value }).then(
                    (res) => {
                        console.log("res", res);
                        loading.close();
                        this.tableGetList(this.table.searchForm);
                    },
                    (res) => {
                        Message({
                            message: res.message,
                            type: "error",
                            duration: 1500,
                            onClose: () => {
                                loading.close();
                            },
                        });
                    }
                );
            },
            branchDelete(row) {
                this.$confirm("确定进行删除操作吗?", "Tips", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                }).then(
                    () => {
                        const loading = this.$loading({
                            lock: true,
                            text: "正在处理...",
                        });
                        branchDelete(row).then(
                            (res) => {
                                loading.close();
                                this.$message({
                                    message: res.message,
                                    type: "success",
                                });
                                this.tableGetList(this.table.searchForm);
                            },
                            (res) => {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "error",
                                    onClose() {
                                        loading.close();
                                    },
                                });
                            }
                        );
                    },
                    () => {}
                );
            },
            // 表格: 列表查询方法
            tableGetList(searchForm) {
                branchList(searchForm.createTime ? { ...searchForm, createTime: `${searchForm.createTime[0]},${searchForm.createTime[1]}` } : { ...searchForm })
                    .then(
                        (res) => {
                            this.table.total = res.data.total;
                            this.table.tableList = res.data.list;
                            console.log("this.table.tableList", this.table.tableList);
                        },
                        (res) => {
                            Message({
                                message: `${res.message}`,
                                type: "error",
                                duration: 1500,
                            });
                        }
                    )
                    .catch((error) => {
                        Message({
                            message: `${error}`,
                            type: "error",
                            duration: 1500,
                        });
                    });
            },
            // 表格: 点击重置搜索条件时
            tableResetForm() {
                this.table.searchForm = {
                    pageNo: 1,
                    pageSize: 10,
                };
                this.tableGetList(this.table.searchForm);
            },
            // 表格: 点击表格的行时
            tableHandleRowClick(row, column, event) {
                this.$refs.table.toggleRowSelection(row);
            },
            // 表格: 点击搜索按钮时
            tableSearch() {
                console.log(this.table.searchForm);
                this.tableGetList(this.table.searchForm);
            },
            // 分页器: 每页条数发生变化时
            pagerHandleSizeChange(val) {
                this.table.searchForm.pageSize = val;
                this.tableGetList(this.table.searchForm);
            },
            // 分页器: 翻页时
            pagerHandleCurrentChange(val) {
                this.table.searchForm.pageNo = val;
                this.tableGetList(this.table.searchForm);
            },
        },
    };
</script>
<style lang="scss" scoped>
    .title {
        display: flex;
        justify-content: space-between;
        padding-right: 10px 10px;
        margin-left: 10px;
        border-bottom: 1px solid #dcdfe6;
        margin-bottom: 10px;
        h4 {
            margin: 0;
            font-size: 14px;
            color: #333;
            padding-bottom: 10px;
            border-bottom: 2px solid rgb(166, 59, 58);
        }
    }
    .searchBox {
        display: flex;
        .searchBtnBox {
            padding-left: 10px;
            // margin-left: 10px;
            ::v-deep .el-form-item--mini.el-form-item,
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 6px !important;
            }
        }
        .inpBox {
            ::v-deep .el-form-item--mini.el-form-item,
            ::v-deep .el-form-item--small.el-form-item {
                margin-bottom: 6px !important;
            }
            ::v-deep .el-form-item.long {
                width: 100%;
                margin-right: 0 !important;
            }
            ::v-deep .el-input__inner {
                width: 150px !important;
            }
            ::v-deep .el-date-editor {
                width: 350px !important;
            }
        }
    }
    .table {
        ::v-deep .el-table {
            color: #333;
            th {
                background-color: #f5f5f5;
                height: 40px;
                color: #333333 !important;
                padding: 2px 0 !important;
                &:first-child .cell {
                    padding: 0 10px 0 10px;
                }
            }
            tr {
                height: 32px;
                &:nth-child(even) {
                    background-color: #f8fafd;
                }
            }
            td {
                padding: 2px 0 !important;
            }
            .cell {
                text-align: center;
                padding: 0 10px;
            }
            .el-button--primary {
                background-color: rgb(166, 59, 58);
            }
            .el-button--primary:focus,
            .el-button--primary:hover {
                background: rgb(166, 59, 58);
                border-color: rgb(166, 59, 58);
                color: #fff;
            }
            .el-button {
                padding: 7px 15px;
            }
            .el-button--text {
                padding: 0;
            }
            .bigBtn {
                padding: 12px 28px;
            }
            .el-button--text {
                color: rgb(24, 148, 219);
            }
            .el-button--text:focus,
            .el-button--text:hover {
                color: rgb(24, 148, 219);
            }
            .el-table__body tr.hover-row > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
            .el-table__body tr.current-row > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
            .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: rgba(14, 110, 236, 0.3) !important;
            }
        }
    }
    .el-dialog__wrapper {
        ::v-deep .el-dialog__header {
            padding: 8px 20px !important;
            background-color: rgb(166, 59, 58);
            .el-dialog__title {
                color: #fff;
            }
            .el-dialog__headerbtn {
                top: 12px;
                .el-dialog__close {
                    color: #fff;
                }
            }
        }
        .hidden ::v-deep .el-upload--picture-card {
            display: none;
        }
        .addressBox .title {
            margin-top: 0;
            margin-left: 10px;
            font-size: 14px;
            margin-bottom: 20px;
            .iconFont {
                color: rgb(166, 59, 58);
                margin-right: 4px;
                font-size: 14px;
            }
        }
        ::v-deep .el-upload--picture-card {
            background-image: url("../../assets/images/upload.png");
            background-size: 150%;
            background-position: 50% 50%;
        }
    }
</style>
